module.exports = __webpack_public_path__ + "img/bulle-success.c5bfe015.png";